import React from "react";
import Card from "../../components/page/Card";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import ButtonRounded from "../../components/buttons/ButtonRounded";
import DadosPessoais from "./Colaborador/DadosPessoais";
import DadosContratuais from "./Colaborador/DadosContratuais";
import { useParams } from "react-router-dom";
import DocumentosColaborador from "./Colaborador/DocumentosColaborador";
import Ferias from "./Colaborador/Ferias";
import JornadaModal from "./JornadaTrabalho/JornadaModal";
import UploadDocumentoModal from "./Colaborador/UploadDocumentoModal";
import FeriasModal from "./Colaborador/FeriasModal";
import DocumentoModal from "../../components/Common/DocumentoModal";
import CommonSwal from "../../components/Swal/commonSwal";
import useFerias from "../../hooks/colaboradores/useFerias";
import useDocumentosColaborador from "../../hooks/colaboradores/useDocumentosColaborador";
import useDadosContratuais from "../../hooks/colaboradores/useDadosContratuais";
import useDadosPessoais from "../../hooks/colaboradores/useDadosPessoais";
import useDocumentos from "../../hooks/common/useDocumentos";
import useLocalidade from "../../hooks/common/useLocalidade";
import { AppContext } from "../../contexts/AppContext";
import TabPane from "../../components/Tab/TabPane";
import OptionsSwal from "../../components/Swal/optionsSwal";

function Ativo() {
  const [tabAtual, setTabAtual] = React.useState(0);
  const [editavel, setEditavel] = React.useState(false);
  const [estadosNascimento, setEstadosNascimento] = React.useState({});
  const [estadoNascimento, setEstadoNascimento] = React.useState("");
  const { session, baseUrl } = React.useContext(AppContext);
  const { uid } = useParams();

  const {
    dependentes,
    salvaDadosPessoais,
    municipioAtivo,
    dadosPessoaisValues,
    setDadosPessoaisValues,
    novoDependente,
    excluirDependente,
    dadosPessoaisOriginalValues,
    setDadosPessoaisOriginalValues,
  } = useDadosPessoais(uid);
  const { estados, municipios, getMunicipios, getCep, cepResponse } =
    useLocalidade(estadoNascimento);
  const {
    jornadas,
    jornada,
    jornadaModal,
    setJornadaModal,
    jornadaValues,
    setJornadaValues,
    togNovaJornadaModal,
    salvaDadosContratuais,
    dadosContratuaisValues,
    setDadosContratuaisValues,
    salvaJornada,
    dadosContratuaisOriginalValues,
    setDadosContratuaisOriginalValues,
  } = useDadosContratuais(uid);
  const {
    uploadValues,
    setUploadValues,
    documentos,
    uploadDocumentoModal,
    setUploadDocumentoModal,
    togUploadModal,
    excluirDocumento,
    uploadDocumento,
  } = useDocumentosColaborador(uid);
  const {
    ferias,
    feriasModal,
    setFeriasModal,
    feriasValues,
    setFeriasValues,
    togFeriasModal,
    excluirFerias,
    salvarFerias,
  } = useFerias(uid);
  const {
    documento,
    documentoModal,
    setDocumentoModal,
    togDocumentoModal,
    downloadDocumento,
  } = useDocumentos();

  // Busca municipios ao alterar valor do campo estado
  React.useEffect(() => {
    if (!estadoNascimento) return;
    getMunicipios();
  }, [getMunicipios, estadoNascimento]);

  // Define uid do estado selecionado
  React.useEffect(() => {
    if (!dadosPessoaisValues?.uf_nascimento || Object.keys(estados) < 1) return;
    const selectUF = document.getElementById("uf_nascimento");
    const selectedOption = selectUF.selectedOptions[0];
    const ufId = selectedOption ? selectedOption.dataset.ufid : null;
    setEstadoNascimento(ufId);
  }, [estados, dadosPessoaisValues?.uf_nascimento, setDadosPessoaisValues]);

  // Define cidade de nascimento caso nenhuma esteja selecionada
  React.useEffect(() => {
    if (
      !municipioAtivo ||
      Object.keys(municipios) < 1 ||
      dadosPessoaisValues?.cidade_nascimento
    )
      return;
    setDadosPessoaisValues((prevValues) => ({
      ...prevValues,
      cidade_nascimento: municipioAtivo,
    }));
  }, [
    municipioAtivo,
    municipios,
    dadosPessoaisValues?.cidade_nascimento,
    setDadosPessoaisValues,
  ]);

  // Verifica se o usuário pode editar os campos
  React.useEffect(() => {
    if (session.codigo !== "99") {
      setEditavel(false);
    } else {
      setEditavel(true);
    }
  }, [session.codigo]);

  React.useEffect(() => {
    if (Object.keys(estados).length === 0) return;

    setEstadosNascimento({
      ...estados,
      EX: {
        id: "EX",
        sigla: "EX",
      },
    });
  }, [estados]);

  const salvaColaborador = async () => {
    await salvaDadosPessoais();
    await salvaDadosContratuais();
    CommonSwal({ text: "Dados salvos com sucesso!", icon: "success" });
    setDadosPessoaisOriginalValues(dadosPessoaisValues);
    setDadosContratuaisOriginalValues(dadosContratuaisValues);
  };

  const retornar = async () => {
    const comparaDiferencas = (valores, valoresOriginais) => {
      const camposIgnorados = [
        "nome_dependente",
        "cpf_dependente",
        "data_nascimento_dependente",
        "tipo_dependente",
      ];

      const chaves = Object.keys({
        ...valores,
        ...valoresOriginais,
      }).filter((key) => !camposIgnorados.includes(key));

      const chavesDiferentes = chaves.filter(
        (key) => String(valores[key]) !== String(valoresOriginais[key])
      );

      chavesDiferentes.forEach((key) => {
        console.warn(
          `Chave diferente: ${key}, Valor atual: ${valores[key]}, Valor original: ${valoresOriginais[key]}`
        );
      });

      return chavesDiferentes.length > 0;
    };

    const possuiDiferencasP = comparaDiferencas(
      dadosPessoaisValues,
      dadosPessoaisOriginalValues
    );

    const possuiDiferencasC = comparaDiferencas(
      dadosContratuaisValues,
      dadosContratuaisOriginalValues
    );

    if (possuiDiferencasP || possuiDiferencasC)
      return OptionsSwal({
        icon: "warning",
        title: "Deseja salvar as alterações realizadas?",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await salvaDadosPessoais();
          await salvaDadosContratuais();
          window.location.href = `${baseUrl}colaboradores/Colaboradores`;
        }
        if (result.isDenied) {
          window.location.href = `${baseUrl}colaboradores/Colaboradores`;
        }
      });
    else window.location.href = `${baseUrl}colaboradores/Colaboradores`;
  };

  return (
    <>
      <Card>
        <div className="row my-3">
          <div style={{ justifyContent: "end", display: "flex" }}>
            <ButtonRounded
              color="orange"
              onClick={() => {
                window.open(process.env.REACT_APP_NOVO_TICKET_URL, "_blank");
              }}
            >
              <i className="bx bx-support me-1"></i>Solicitar alteração
            </ButtonRounded>
          </div>
        </div>
        <TabList>
          <TabButton
            href="pessoaisTab"
            ativo={true}
            onClick={() => {
              setTabAtual(0);
            }}
          >
            Dados pessoais
          </TabButton>
          <TabButton
            href="contratuaisTab"
            onClick={() => {
              setTabAtual(1);
            }}
          >
            Dados contratuais
          </TabButton>
          <TabButton
            href="documentosTab"
            onClick={() => {
              setTabAtual(2);
            }}
          >
            Documentos do colaborador
          </TabButton>
          <TabButton
            href="feriasTab"
            onClick={() => {
              setTabAtual(3);
            }}
          >
            Férias
          </TabButton>
        </TabList>
        <TabContent>
          <TabPane id="pessoaisTab" ativo={true}>
            <DadosPessoais
              valuesHook={{
                values: dadosPessoaisValues,
                setValues: setDadosPessoaisValues,
              }}
              estados={estadosNascimento}
              municipios={municipios}
              cepApi={{ getCep, cepResponse }}
              dependentes={dependentes}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              editavel={editavel}
              novoDependente={novoDependente}
              excluirDependente={excluirDependente}
              retornar={retornar}
            />
          </TabPane>
          <TabPane id="contratuaisTab">
            <DadosContratuais
              valuesHook={{
                values: dadosContratuaisValues,
                setValues: setDadosContratuaisValues,
              }}
              jornadas={jornadas}
              jornada={jornada}
              togNovaJornadaModal={togNovaJornadaModal}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              editavel={editavel}
              retornar={retornar}
            />
          </TabPane>
          <TabPane id="documentosTab">
            <DocumentosColaborador
              linhas={documentos}
              togUploadModal={togUploadModal}
              togDocumentoModal={togDocumentoModal}
              downloadDocumento={downloadDocumento}
              excluirDocumento={excluirDocumento}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              editavel={editavel}
              retornar={retornar}
            />
          </TabPane>
          <TabPane id="feriasTab">
            <Ferias
              linhas={ferias}
              togFeriasModal={togFeriasModal}
              togDocumentoModal={togDocumentoModal}
              downloadDocumento={downloadDocumento}
              excluirFerias={excluirFerias}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              editavel={editavel}
              retornar={retornar}
            />
          </TabPane>
        </TabContent>
      </Card>
      <JornadaModal
        valuesHook={{ values: jornadaValues, setValues: setJornadaValues }}
        isOpen={jornadaModal}
        setIsOpen={setJornadaModal}
        novo={true}
        salvaJornada={salvaJornada}
      />
      <UploadDocumentoModal
        isOpen={uploadDocumentoModal}
        setIsOpen={setUploadDocumentoModal}
        valuesHook={{ uploadValues, setUploadValues }}
        uploadDocumento={uploadDocumento}
      />
      <FeriasModal
        isOpen={feriasModal}
        setIsOpen={setFeriasModal}
        valuesHook={{ feriasValues, setFeriasValues }}
        salvarFerias={salvarFerias}
      />
      <DocumentoModal
        documento={documento}
        modalHook={{ documentoModal, setDocumentoModal }}
      />
    </>
  );
}

export default Ativo;
